import '../components/layout/layout.js';

declare global {
  interface Window {
    loadCSS: (href: string) => void;
  }
}

((window) => {
  const loadCss = () => {
    Array.prototype.forEach.call(document.querySelectorAll('meta[name="css:lazyload"]'), (element: HTMLElement) => {
      const content = element.getAttribute('content');
      if (typeof content === 'string') {
        window.loadCSS(content);
      }
      element.remove();
    });
  };
  loadCss();
})(window);
